import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: null,
  search: null,
};

const couponFilterSlice = createSlice({
  name: "couponFilter",
  initialState,
  reducers: {
    setCouponStatusFilter: (state, action) => {
      state.status = action.payload ?? null;
    },
    setCouponSearchFilter: (state, action) => {
      state.search = action.payload ?? null;
    },
    clearCouponFilter: () => ({ status: null, search: null }),
  },
});

export const {
  setCouponSearchFilter,
  setCouponStatusFilter,
  clearCouponFilter,
} = couponFilterSlice.actions;

export const selectCouponFilter = (state) => state.couponFilter;

export default couponFilterSlice.reducer;
